import { handleActions } from 'redux-actions'
import { AiAssistActionTypes } from '../actions/aiAssist'

type InverseData = {
  start_stage: number
  end_stage: number
  objectives: Record<string, any>
} | null

export type AiAssistState = {
  inverseData: InverseData
  isInverseDataSet: boolean
}

const defaultState: AiAssistState = {
  inverseData: null,
  isInverseDataSet: false
}

const aiAssistReducer = handleActions(
  {
    [AiAssistActionTypes.SET_INVERSE_DATA]: (state, action:any) => ({
      ...state,
      inverseData: action.payload
    }),
    [AiAssistActionTypes.SET_INVERSE_DATA_SUCCESS]: (state, action:any) => ({
        ...state,
        isInverseDataSet: true
      }),
    [AiAssistActionTypes.CLEAR_INVERSE_DATA]: (state, action:any) => ({
        ...state,
        inverseData: null,
        isInverseDataSet: false
      })
  },
  defaultState
)

export default aiAssistReducer
